import { getHoursAndMinutesFromMinutes } from '@/utils';
import { useTranslation } from 'react-i18next';
import { Abweichung } from '../../../Abweichung';

export function DauerCellContent({
  dauer = 0,
  abweichung,
}: {
  dauer?: number;
  abweichung?: number;
}) {
  const { hours, minutes } = getHoursAndMinutesFromMinutes(dauer);
  const { t } = useTranslation();
  let abweichungComponent = <></>;
  if (abweichung !== undefined && abweichung !== 0 && dauer !== 0) {
    abweichungComponent = <Abweichung abweichung={abweichung} />;
  }

  return (
    <div className="flex flex-col gap-2 items-center font-semibold pe-4">
      <div className="flex gap-1 items-baseline">
        {hours}
        <span className="text-neutrals-700 text-xs">
          {t('general.date.hours')}
        </span>
        {minutes}
        <span className="text-neutrals-700 text-xs">
          {t('general.date.minutes')}
        </span>
      </div>
      {abweichungComponent}
    </div>
  );
}
